// @flow
import { connect } from 'react-redux'
import AdsList, { type Props } from './AdsList'
import * as actions from '../../redux/ducks/copiedAdvertisementList/reducers'
import { getAdvertisement, getMedia } from '../../redux/selectors'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'
import type { AdvertisementStatistics, AudienceData, Configs } from '../types'

type OwnProps = {|
  action: 'copy' | 'update' | 'create',
  statistics: { [number]: AdvertisementStatistics },
  audienceData: AudienceData,
  errors: Array<string>,
  disabled?: boolean,
  configs: Configs
|}

function mapStateToProps(state: Store) {
  const advertisements: Array<Object> = _.map(state.copiedAdvertisementList.storeIds, (storeId) => {
    const ad = getAdvertisement(state, storeId)
    const { multiImageStoreId } = ad
    const smallImageStoreId = ad.tmSmallImageStoreId
    return {
      storeId,
      ad: {
        ...ad,
        image: multiImageStoreId ? getMedia(state, multiImageStoreId) : null,
        smallImage: smallImageStoreId ? getMedia(state, smallImageStoreId) : null
      }
    }
  })
  return {
    ...state.copiedAdvertisementList,
    advertisements
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onToggle: (storeId) => dispatch(actions.toggle(storeId))
  }
}

const AdsListContainer = connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AdsList)

export default AdsListContainer
